import ButtonJustifyEnd from "components/ButtonJustifyEnd";
import Loading from "components/Loading";
import TextInputAuth from "components/TextInputAuth";
import Title from "components/Title";
import handleErrors from "helpers/handleErrors";
import toastMessage from "helpers/handleToastMessage";
import IconArrowRight from "icons/arrow-circle-right-white.svg";
import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { CreateAssignSubscriptionStep2 } from "services/manageFamilies";
import { meGet } from "services/me";
import ChooseYourPlan from "./ChooseYourPlan";
import SubTitle from "./SubTitle";
import { schemaChildrenNames } from "./validation";

type Props = {
  setSteps: React.Dispatch<React.SetStateAction<number>>;
  setGroupChildrenName: React.Dispatch<React.SetStateAction<string>>;
};

const ChildrenNames: React.FC<Props> = ({
  setSteps,
  setGroupChildrenName,
}): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const [loadingMe, setLoadingMe] = useState(false);
  const [childrenFirstName, setChildrenFirstName] = useState("");
  const [childrenLastName, setChildrenLastName] = useState("");
  const [errors, setErrors] = useState<any>();
  const [idSelected, setIdSelected] = useState("");
  const [user, setUser] = useState<any>();
  const [couponCode, setCouponCode] = useState("");

  const [groupId, setGroupId] = useState("");

  const me = async () => {
    try {
      setLoadingMe(true);
      const { data } = await meGet();
      setUser(data);
    } catch (error: any) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setLoadingMe(false);
    }
  };

  useEffect(() => {
    const groupId = localStorage.getItem("groupId");
    if (groupId) {
      setGroupId(groupId);
      me();
    }
  }, []);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (
        !schemaChildrenNames.isValidSync({
          childrenFirstName,
          childrenLastName,
          idSelected,
        })
      ) {
        handleErrors({
          schema: schemaChildrenNames,
          stateData: {
            childrenFirstName,
            childrenLastName,
            idSelected,
          },
          setErrorMessage: setErrors,
        });
        setLoading(false);
        return;
      }

      setGroupChildrenName(`${childrenFirstName} ${childrenLastName}`);

      const { data } = await CreateAssignSubscriptionStep2({
        coupons: [user.coupon, couponCode],
        priceId: idSelected,
        groupId,
        name: `${childrenFirstName} ${childrenLastName}`,
      });

      if (data._id) {
        toastMessage({
          message: "Group created successfully.",
          type: "success",
        });
        setSteps(3);
      }
    } catch (error: any) {
      let message = "Error, Something went wrong.";

      if (error.response.data.message === "Group already has a subscription.") {
        message = error.response.data.message;
      }

      if (
        error.response.data.message ===
        "Coupon Free is used up and cannot be applied."
      ) {
        message = error.response.data.message;
      }

      toastMessage({
        message: message,
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-bt-white p-4">
      <Loading loading={loading || loadingMe} />
      <div className="w-9/12 mx-auto mt-4">
        <Title title={"Please type the child’s name"} />
        <div className="flex flex-row mx-48">
          <div className="flex flex-col w-1/2 mr-4">
            <TextInputAuth
              placeholder={"First Name"}
              label="Child’s First Name"
              value={childrenFirstName}
              onChange={(e: any) => setChildrenFirstName(e.target.value)}
              isHelp={errors?.childrenFirstName}
              helpText={errors?.childrenFirstName}
            />
          </div>
          <div className="flex flex-col w-1/2 ml-4">
            <TextInputAuth
              placeholder={"Last Name"}
              label="Child’s Last Name"
              value={childrenLastName}
              onChange={(e: any) => setChildrenLastName(e.target.value)}
              isHelp={errors?.childrenLastName}
              helpText={errors?.childrenLastName}
            />
          </div>
        </div>
        <SubTitle />
        {user && (
          <ChooseYourPlan
            entityCoupon={user?.coupon || ""}
            setLoading={setLoading}
            setIdSelected={setIdSelected}
            idSelected={idSelected}
            couponCode={couponCode}
            setCouponCode={setCouponCode}
            errors={errors}
          />
        )}
      </div>

      <ButtonJustifyEnd
        title={"Continue"}
        iconRight={IconArrowRight}
        action={handleSubmit}
      />
      <ToastContainer />
    </div>
  );
};

export default ChildrenNames;
